import { Divider, Typography, TypographyProps } from '@mui/material';

interface IConvergeSectionTitleProps extends TypographyProps {
  showSeparator?: boolean;
}

export const ConvergeSectionTitle = ({
  showSeparator,
  ...props
}: IConvergeSectionTitleProps) => {
  return (
    <>
      <Typography
        sx={{
          color: ' black',
          fontSize: '20px',
          fontWeight: '500',
        }}
        variant="h4"
        color="primary"
        mb={!showSeparator ? 2 : undefined}
        {...props}
      />
      {showSeparator && <Divider sx={{ mb: 2, mt: 1 }} />}
    </>
  );
};
